export default "__VITE_ASSET__C35WFxB1__"